import { useContext } from 'react';
import { ViewBudgetPeriodContext } from 'src/sections/view_budget_period/ViewBudgetPeriodContext';

const useViewBudgetPeriod = () => {
  const context = useContext(ViewBudgetPeriodContext);
  if (!context)
    throw new Error(
      'View Budget Period context must be used inside ViewBudgetPeriodContextProvider'
    );
  return context;
};

export default useViewBudgetPeriod;
